// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 15;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(4px);
}
.dialog__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--sebrae-gray);
  opacity: 0.5;
  display: block;
}
.dialog__content {
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 130px;
  border-radius: 4px;
  border: 2px solid var(--sebrae-light-blue3);
  background-color: var(--sebrae-white);
  color: var(--sebrae-gray);
  box-shadow: 0 32px 30px 0 rgba(20, 46, 82, 0.2);
}
.dialog__header {
  position: relative;
  width: 100%;
  min-height: 40px;
  padding: 14px 30px 14px 16px;
  border-bottom: 1px solid var(--sebrae-light-gray4);
  display: flex;
  align-items: center;
}
.dialog__header h4 {
  font-weight: 700;
  font-size: 16px;
}
.dialog__header .btn-without-style {
  position: absolute;
  right: 8px;
}
.dialog__body {
  position: relative;
  width: 100%;
  padding: 16px;
}
.dialog__body p {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.2;
  margin: 13px 0;
}
.dialog__buttons {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 14px;
}
@media screen and (min-width: 768px) {
  .dialog__header h4 {
    font-size: 23px;
  }
  .dialog__body p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dialog/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;AACJ;AACE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qCAAA;EACA,yBAAA;EACA,+CAAA;AACJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EAEI,gBAAA;EACA,eAAA;AAAR;AAII;EACE,kBAAA;EACA,UAAA;AAFN;AAKE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AAHJ;AAKI;EAEI,gBAAA;EACA,eAAA;EAEF,gBAAA;EACA,cAAA;AALN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AANJ;AASE;EAEI;IACE,eAAA;EARN;EAYI;IACE,eAAA;EAVN;AACF","sourcesContent":[".dialog {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  backdrop-filter: blur(4px);\r\n  \r\n  &__overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: var(--sebrae-gray);\r\n    opacity: .5;\r\n    display: block;\r\n  }\r\n  &__content {\r\n    position: relative;\r\n    z-index: 1;\r\n    width: 100%;\r\n    min-height: 130px;\r\n    border-radius: 4px;\r\n    border: 2px solid var(--sebrae-light-blue3);\r\n    background-color: var(--sebrae-white);\r\n    color: var(--sebrae-gray);\r\n    box-shadow: 0 32px 30px 0 rgba(20, 46, 82, 0.20);\r\n  }\r\n  &__header {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 40px;\r\n    padding: 14px 30px 14px 16px;\r\n    border-bottom: 1px solid var(--sebrae-light-gray4);\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    h4 {\r\n      font: {\r\n        weight: 700;\r\n        size: 16px;\r\n\r\n      }\r\n    }\r\n    .btn-without-style {\r\n      position: absolute;\r\n      right: 8px;\r\n    }\r\n  }\r\n  &__body {\r\n    position: relative;\r\n    width: 100%;\r\n    padding: 16px;\r\n\r\n    p {\r\n      font: {\r\n        weight: 400;\r\n        size: 13px;\r\n      }\r\n      line-height: 1.2;\r\n      margin: 13px 0;\r\n    }\r\n  }\r\n  &__buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding-top: 14px;\r\n  }\r\n\r\n  @media screen and (min-width: 768px) {\r\n    &__header {\r\n      h4 {\r\n        font-size: 23px;\r\n      }\r\n    }\r\n    &__body {\r\n      p {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
